import moment from 'moment-timezone';
import React, { createContext, useContext, useMemo, useState } from 'react';

const today = moment().format('YYYY-MM-DD');

const DateContext = createContext({
  date: today,
  // eslint-disable-next-line
  setDate: (value: string) => {},
});

export const TargetDateProvider = ({ children }: { children: React.ReactNode }) => {
  const [date, setDate] = useState(today);

  const ctx = useMemo(() => ({ date, setDate }), [date]);

  return <DateContext.Provider value={ctx}>{children}</DateContext.Provider>;
};

export const useTargetDate = () => useContext(DateContext);
